export const SUPPLIER_CLEAR = 'SUPPLIER_CLEAR'
export const SUPPLIERS_CLEAR = 'SUPPLIERS_CLEAR'
export const LOAD_SUPPLIERS = 'LOAD_SUPPLIERS'
export const LOAD_SUPPLIER = 'LOAD_SUPPLIER'
export const EXTEND_SUPPLIERS = 'EXTEND_SUPPLIERS'
